import * as React from 'react';
import { Action } from 'redux';

import { WelcomeChannelStyles } from '../styles/WelcomeChannelStyles';
import { WelcomeChannelActions, WelcomeChannelLinkDetails } from '../utils/WelcomeChannelLinks';
import { WelcomeChannelActionTypes, WelcomeChannelTestIds } from './WelcomeChannel';

/**
 * Welcome Screen List of Links Component
 */

type SendTelemetryEvent = (actionType: WelcomeChannelActionTypes, action: WelcomeChannelActions) => void;

interface WelcomeChannelLinkListProps {
  links: WelcomeChannelLinkDetails[];
  dispatchAction: (action: Action) => void;
  sendTelemetryEvent: SendTelemetryEvent;
}

export class WelcomeChannelLinkList extends React.PureComponent<WelcomeChannelLinkListProps> {
  render() {
    return (
      <p className={WelcomeChannelStyles.links}>
        {this.props.links.map((link, index) => (
          <WelcomeChannelLink
            key={index}
            actionName={link.actionName}
            dispatchAction={this.props.dispatchAction}
            sendTelemetryEvent={this.props.sendTelemetryEvent}
            getAction={link.getAction}
            onClick={link.onClick}
            linkTitle={link.linkTitle}
            openNewTab={link.openNewTab}
            position={index}
            url={link.url}
          />
        ))}
      </p>
    );
  }
}

/**
 * Welcome Screen Link Component
 */

export interface WelcomeChannelLinkProps extends WelcomeChannelLinkDetails {
  actionName: WelcomeChannelActions;
  position: number;
  dispatchAction: (action: Action) => any;
  sendTelemetryEvent: SendTelemetryEvent;
}

export class WelcomeChannelLink extends React.PureComponent<WelcomeChannelLinkProps> {

  render() {
    const divider = <>{this.props.position !== 0 && <span className={WelcomeChannelStyles.linkDivider}>|</span>}</>;
    const linkComponent = this.props.url ? this.generateLink() : this.generateButton();
    return (
      <>
        {divider}
        {linkComponent}
      </>
    );
  }

  private generateLink() {
    return (
      <a className={WelcomeChannelStyles.link}
        href={this.props.url}
        target={this.props.openNewTab ? '_blank' : '_self'}
        data-tb-test-id={WelcomeChannelTestIds.welcomeChannelLink}
      >
        {this.props.linkTitle}
      </a>
    );
  }

  private generateButton() {
    return (
      <button
        className={WelcomeChannelStyles.link}
        onClick={() => this.handleAction()}
        data-tb-test-id={WelcomeChannelTestIds.welcomeChannelButtonLink}
      >
        {this.props.linkTitle}
      </button>
    );
  }

  private handleAction() {
    this.props.sendTelemetryEvent(WelcomeChannelActionTypes.secondary, this.props.actionName);

    if (this.props.getAction) {
      this.props.dispatchAction(this.props.getAction());
    }
    if (this.props.onClick) {
      this.props.onClick();
    }
  }
}
